// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__swoQc","tooltip-content":"Tooltip_tooltip-content__do2L8","tooltip-button-close":"Tooltip_tooltip-button-close__08xop"};